export default {
  getSystemHealth: {
    url: "/tacos-cloud-instance/front/console/operation/system/health/",
    method: "get",
    desc: "健康与升级",
    topTips: true
  }
};
